"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Checkmark = _interopRequireDefault(require("@commerce-ui/core2/selectables/Checkmark"));
var _excluded = ["color"];
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultProps = {
  color: "main"
};
var Checkmark = function Checkmark(props) {
  var _props$color = props.color,
    color = _props$color === void 0 ? defaultProps.color : _props$color,
    restProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return __jsx(_Checkmark["default"], (0, _extends2["default"])({}, restProps, {
    sx: function sx(_ref) {
      var selected = _ref.selected,
        disabled = _ref.disabled,
        invalid = _ref.invalid;
      return _objectSpread({
        bg: "white",
        transition: "all .1s",
        borderWidth: "1px",
        borderStyle: "solid",
        width: 24,
        height: 24,
        borderColor: invalid ? "negative" : selected ? "darkBlue" : "neutral",
        borderRadius: props.rounded ? 50 : 4,
        $icon: {
          size: 10,
          color: disabled ? "white" : selected ? "darkBlue" : "white"
        }
      }, props.sx);
    }
  }));
};
var _default = Checkmark;
exports["default"] = _default;